import { VersionState, VersionStates } from '../../../types/api/VersionState';
import { StateIndicator } from './StateIndicator';
import { PagePackState, PagePackStates } from '../../../types/api/PagePackState';

export const getStatusByVersionState = (versionState: VersionStates): StateIndicator['status'] => {
  switch (versionState) {
    case VersionState.published:
      return 'green';
    case VersionState.draft:
      return 'yellow';
    case VersionState.publishedHistory:
    default:
      return 'red';
  }
};

export const getStateIndicatorByPagePackState = (pagePackState: PagePackStates): StateIndicator['status'] => {
  switch (pagePackState) {
    case PagePackState.ONLY_DRAFT_VERSION:
      return 'red';
    case PagePackState.PUBLISHED_WITH_DRAFT_VERSION:
      return 'yellow';
    case PagePackState.ONLY_PUBLISHED_VERSION:
    default:
      return 'green';
  }
};
